/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Record_Voiceover_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Record voiceover" |
*
* @param {Event_Ad_Record_Voiceover_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_record_voiceover_aria_label = /** @type {((inputs?: Event_Ad_Record_Voiceover_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Record_Voiceover_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer une voix off")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachaufnahme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra la voce fuori campo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись закадрового голоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grabar voz en off")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制旁白")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ナレーションを録音する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉयसओवर रिकॉर्ड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gravar locução")
	return /** @type {LocalizedString} */ ("Record voiceover")
});